export function toFormData(object: Object, form?: FormData, namespace?: string, fieldsSkipValueChecking?: string[]): FormData {
  const formData = form || new FormData()
  for (const property in object) {
    if (!object.hasOwnProperty(property)) {
      continue
    }

    const formKey = namespace ? `${namespace}[${property}]` : property

    if (fieldsSkipValueChecking?.includes(property)) {
      formData.append(formKey, object[property])
    } else {
      if (typeof object[property] === 'object' && !(object[property] instanceof File)) {
        toFormData(object[property], formData, formKey)
      } else {
        const value = object[property] === undefined || object[property] === null ? '' : object[property]
        formData.append(formKey, value)
      }
    }
  }

  return formData
}
